import type { SVGProps } from '@/types/common.types';

const SubscriptionAmediatekaSVG = (props: SVGProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="210"
      height="20"
      viewBox="0 0 210 20"
      fill="none"
      {...props}
    >
      <path
        d="M14.32 17.3587H5.58L4.24875 20H0L9.9525 0L19.9025 20H15.65L14.3188 17.3587H14.32ZM7.285 13.9175H12.5787L9.9125 8.605L7.285 13.9175ZM34.075 14.4812L28.675 9.525V20H24.5375V0L34.0462 8.9025L43.6712 0V20H39.55V9.525L34.075 14.4812ZM65.0212 4.57H55.7788V8.27875H64.1338V12.135H55.7788V16.14H65.16V19.9963H51.6425V0.7125H65.0212V4.57ZM88.6125 10.475C88.6125 16.1125 84.51 20 78.3075 20H72.1675V0.7175H78.4863C84.7463 0.71125 88.6125 4.7775 88.6125 10.475ZM84.48 10.3562C84.48 6.715 82.1175 4.5725 78.7513 4.5725H76.2988V16.1413H78.7213C82.0275 16.1413 84.48 14.005 84.48 10.3562ZM93.455 0.7125H105.326V4.5675H101.456V16.1375H105.326V19.9937H93.455V16.1375H97.325V4.5675H93.455V0.7125ZM123.81 17.3587H115.069L113.741 20H109.478L119.429 0L129.381 20H125.118L123.81 17.3587ZM116.775 13.9175H122.06L119.401 8.605L116.775 13.9175ZM129.774 0.7125H146.309V4.5675H140.11V19.9937H135.975V4.56875H129.774V0.71V0.7125ZM165.03 4.57H155.787V8.27875H164.145V12.135H155.787V16.14H165.169V19.9963H151.645V0.7125H165.021L165.03 4.57ZM176.31 11.0675V20H172.176V0.7175H176.31V9.325L182.864 0.71875H187.855L180.685 10.06L188.511 20H183.58L176.31 11.0675ZM204.42 17.3587H195.68L194.351 20H190.098L200.05 0L210 20H205.749L204.42 17.3587ZM197.385 13.9175H202.673L200.014 8.605L197.385 13.9175Z"
        fill="white"
      />
    </svg>
  );
};

export default SubscriptionAmediatekaSVG;
